import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';

export const percentileCalculatorDescription: CalculatorDescription = {
  id: CalculatorId.PERCENTILE,
  title: 'Percentile calculator',
  metaTitle: 'Percentile Calculator - Find Data Position in Distribution',
  description: 'Calculate percentiles to determine the position of a value within a dataset.',
  metaDescription: 'Free online percentile calculator. Find where values fall within your dataset distribution with our easy-to-use statistical tool.',
  howTo: {
    title: 'How to calculate percentiles',
    steps: [
      'Enter your numeric data directly into the data table or upload a CSV file',
      'Use the "Select Data Column" control to choose which column of data to analyze',
      'The calculator will automatically determine key percentile values (25th, 50th, 75th, etc.)',
      'View where specific values fall within your data distribution',
      'Examine the visualization to understand the percentile distribution of your data'
    ],
    graphic: {
      description: 'Visual representation of percentile calculation'
    }
  },
  examples: [
    {
      title: 'Finding percentiles in test scores',
      description: 'Analyzing student performance distribution',
      dataDescription: 'Test scores from a class of 20 students',
      insights: [
        'The 75th percentile is 88, meaning 75% of scores are below 88',
        'The 50th percentile (median) is 82',
        'The 25th percentile is 75, showing the bottom quarter of scores',
        'Percentiles help identify outliers and performance benchmarks'
      ],
      data: TableDataJSON.from({
        columns: [
          { 
            id: 'scores',
            name: 'Test Scores', 
            values: ['65', '70', '72', '75', '75', '76', '78', '80', '80', '82', '82', '83', '85', '85', '86', '88', '90', '92', '95', '98'] 
          }
        ]
      })
    }
  ],
  relatedCalculators: [
    CalculatorId.QUARTILE,
    CalculatorId.MEDIAN,
    CalculatorId.BoxPlot
  ]
}; 